import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IncidentService } from 'src/app/services/api/incident.service';
import { CognitoService } from 'src/app/services/cognito.service';
import Swal from 'sweetalert2';
export interface DialogDeleteOpIncidentData {
  opIncidentId: string;
  itineraryId: string;
  serviceId?: string;
  opIncidentType: string;
}

@Component({
  selector: 'app-dialog-delete-op-incident',
  templateUrl: './dialog-delete-op-incident.component.html',
  styleUrls: ['./dialog-delete-op-incident.component.css']
})
export class DialogDeleteOpIncidentComponent implements OnInit {
  state: 'CONFIRM' | 'LOADING' | 'SUCCESS' | 'ERROR' = 'CONFIRM';
  authUsername: string | null = null;

  constructor(
    private readonly cognitoService: CognitoService,
    private readonly incidentService: IncidentService,
    public dialogRef: MatDialogRef<DialogDeleteOpIncidentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDeleteOpIncidentData
  ) {}

  ngOnInit(): void {
    console.log({ data: this.data });
    this.loadUser();
  }

  loadUser() {
    this.state = 'LOADING';
    return this.cognitoService
      .getUsername()
      .then((username) => {
        console.log({ username });
        this.authUsername = username;
        return username;
      })
      .catch((err) => {
        console.error('Error fetching username:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo obtener el usuario autenticado. Por favor, intente nuevamente. Si el problema persiste, vuelva a iniciar sesión.'
        });
        throw err;
      })
      .finally(() => {
        this.state = 'CONFIRM';
      });
  }

  deleteOpIncident(): void {
    this.state = 'LOADING';

    console.log({
      authUsername: this.authUsername
    });

    if (!this.authUsername || !this.data.itineraryId) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo obtener el usuario autenticado. Por favor, intente nuevamente. Si el problema persiste, vuelva a iniciar sesión.'
      });
      this.state = 'ERROR';
      return;
    }

    this.incidentService
      .deleteOpIncident({
        opIncidentId: this.data.opIncidentId,
        itineraryId: this.data.itineraryId,
        deletedBy: this.authUsername!,
        serviceId: this.data.serviceId
      })
      .subscribe({
        next: (res) => {
          console.log({ res });
          this.state = 'SUCCESS';
        },
        error: (err) => {
          console.error('Error deleting incident:', err);
          this.state = 'ERROR';
        }
      });
  }

  closeDialog(result: boolean = false): void {
    if (result === true) {
      this.dialogRef.close({
        event: 'op_incident_delete',
        op_incident_delete: result
      });
      return;
    }
    this.dialogRef.close({
      event: 'nothing'
    });
  }
}
